var map = {
	"./symbol_0.png": "eca0",
	"./symbol_1.png": "8214",
	"./symbol_2.png": "df69",
	"./symbol_3.png": "b916",
	"./symbol_4.png": "c484",
	"./symbol_5.png": "bb5a",
	"./symbol_6.png": "bc4f",
	"./symbol_7.png": "3a8a",
	"./symbol_8.png": "d3df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adf31";